import isEmpty from 'lodash/isEmpty';
import type { IssueTriggerPayload } from '@atlassian/jira-packages-controllers-use-trigger-issue-create-modal/src/types.tsx';
import type { OldGICPayload } from '../types.tsx';
import { extractEventAttributes } from './extract-event-attributes.tsx';
import { generateDefaultValues } from './generate-default-values.tsx';
import { mergePrefilled, returnActualValue } from './helper-functions.tsx';

export const transformOldGICPayloadToNew = (
	payload: OldGICPayload = {},
	isEcosystemAPI = false,
): IssueTriggerPayload | null => {
	const { prefilledFields: gicPreFilledFields, target = null } = payload;
	let prefilledFields = gicPreFilledFields;
	if (target) {
		const newPayload = extractEventAttributes(target);
		prefilledFields = mergePrefilled(gicPreFilledFields, newPayload.prefilledFields);
	}
	if (!isEmpty(prefilledFields)) {
		const {
			fieldsToRetain = [],
			pid,
			issuetype,
			requestype,
			additionalContext,
			statusId,
			...otherFields
		} = prefilledFields;
		const outputPayload: Partial<IssueTriggerPayload> = {};

		if ((!isEmpty(pid) || typeof pid === 'number') && pid !== 'undefined') {
			outputPayload.project = {
				projectId: returnActualValue(pid),
			};
		}

		if (!isEmpty(issuetype) || typeof issuetype === 'number') {
			outputPayload.issueType = {
				issueTypeId: returnActualValue(issuetype),
			};
		}

		if (!isEmpty(requestype)) {
			outputPayload.requestType = {
				key: returnActualValue(requestype),
			};
		}

		if (!isEmpty(otherFields.parentId)) {
			outputPayload.parentId = {
				parentId: returnActualValue(otherFields.parentId),
			};
		}

		if (!isEmpty(statusId)) {
			outputPayload.status = {
				statusId,
			};
		}

		if (!isEmpty(additionalContext)) {
			outputPayload.additionalContext = additionalContext;
		}
		// for other fields
		if (Object.keys(otherFields).length > 0) {
			const { parentId, ...otherFieldsWithoutParent } = otherFields;
			const { defaultValues, fieldIds } = generateDefaultValues(
				parentId !== undefined && !isEmpty(parentId)
					? { parent: parentId, ...otherFieldsWithoutParent }
					: otherFieldsWithoutParent,
				isEcosystemAPI,
			);
			if (!isEmpty(defaultValues)) {
				outputPayload.defaultValues = defaultValues;
			}
			outputPayload.customFieldsToPreserveOnFormRecreation = [...fieldsToRetain, ...fieldIds];
		}
		return outputPayload;
	}
	return null;
};

export const transformGICPayload = transformOldGICPayloadToNew;
